
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut();
      setShowUserMenu(false);
      navigate('/');
    } catch (error) {
      console.error('로그아웃 실패:', error);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/80 backdrop-blur-xl shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/bc658600574082ef42d46497448eb1f8.jpg" 
                alt="룸팡멤버쉽 로고" 
                className="h-10 w-auto"
              />
              <span className="text-2xl font-extrabold text-white tracking-tight">
                룸팡멤버쉽
              </span>
            </Link>

            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-white/90 hover:text-white font-semibold transition-colors cursor-pointer">
                홈
              </a>
              <a href="/events" className="text-white/90 hover:text-white font-semibold transition-colors cursor-pointer">
                이벤트
              </a>
              <a href="/level" className="text-white/90 hover:text-white font-semibold transition-colors cursor-pointer">
                회원등급
              </a>
              {profile?.is_admin && (
                <a href="/admin" className="text-white/90 hover:text-white font-semibold transition-colors cursor-pointer">
                  관리자
                </a>
              )}
            </div>
          </div>

          <div className="flex items-center gap-4">
            {user ? (
              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="flex items-center gap-2 px-4 py-2 rounded-lg transition-colors text-white hover:bg-white/10"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full text-white">
                    <i className="ri-user-line"></i>
                  </div>
                  <span className="text-sm font-extrabold">{user.email}</span>
                  <i className="ri-arrow-down-s-line"></i>
                </button>

                {showUserMenu && (
                  <>
                    <div
                      className="fixed inset-0 z-10"
                      onClick={() => setShowUserMenu(false)}
                    ></div>
                    <div className="absolute right-0 mt-2 w-48 bg-slate-950 rounded-lg shadow-lg py-2 z-20 border border-white/20">
                      {profile?.is_admin && (
                        <Link
                          to="/admin"
                          onClick={() => setShowUserMenu(false)}
                          className="block px-4 py-2 text-sm text-white hover:bg-white/10 cursor-pointer"
                        >
                          <i className="ri-dashboard-line mr-2"></i>
                          관리자 대시보드
                        </Link>
                      )}
                      <button
                        onClick={handleLogout}
                        className="w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-white/10 cursor-pointer"
                      >
                        <i className="ri-logout-box-line mr-2"></i>
                        로그아웃
                      </button>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <>
                <Link
                  to="/login"
                  className="px-4 py-2 rounded-lg text-sm font-extrabold transition-colors whitespace-nowrap text-white/90 hover:text-white hover:bg-white/10"
                >
                  로그인
                </Link>
                <Link
                  to="/signup"
                  className="px-6 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg text-sm font-extrabold transition-colors whitespace-nowrap border border-white/20"
                >
                  회원가입
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
